import { combineReducers } from 'redux';

import file, { SourceFileState } from './file';
import section, { SourceSectionState } from './section';
import srcDirMetadata, { SourceDirMetadataState } from './src-dir-metadata';

export type SourceState = {
  file: SourceFileState;
  section: SourceSectionState;
  srcDirMetadata: SourceDirMetadataState;
};

export default combineReducers({
  file,
  section,
  srcDirMetadata,
});
